import React, { useContext, useEffect, useState } from 'react';
import './form.css';
import Input from '../../Elements/Inputs/Input';
import { LanguageContext } from '../../../context/LanguageContext/LanguageContext';
import { footerData } from '../../../json/footer';
import useForm from '../../Hooks/UseForm';
import { COTIZACION_FORM } from '../../Constants/Forms/Cotizacion';
import { cotizacionSchema } from '../../Models/Forms/cotizacionSchema';
import Swal from 'sweetalert2';
import { setErrorFormSimpleUtil } from '../../Utilities/Forms/errors';
import Button from '../../Elements/Buttons/Button';
import {
    FaMapMarkerAlt,
    FaPhoneAlt,
    FaEnvelope,
    FaFacebookF,
    FaInstagram,
    FaYoutube,
    FaLinkedinIn,
    FaTiktok,
} from "react-icons/fa";
import { contactoData } from '../../../json/contacto';

const Form = () => {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const { language } = useContext(LanguageContext);
    const data = footerData[language || 'ES'];
    const [isClient, setIsClient] = useState(false);
    const [loading, setLoading] = useState(false);
    const dataContacto = contactoData[language || 'ES'];

    const {
        values,
        errors,
        touched,
        handleBlur,
        handleChange,
        isValid,
        resetForm,
    } = useForm(COTIZACION_FORM, cotizacionSchema);

    const iconMap = {
        FaMapMarkerAlt,
        FaPhoneAlt,
        FaEnvelope,
        FaFacebookF,
        FaInstagram,
        FaYoutube,
        FaTiktok,
        FaLinkedinIn
    };

    useEffect(() => {
        setIsClient(true);
    }, []);

    if (!isClient) return null;

    const handleSubmit = async (values) => {
        if (loading) return;
        setLoading(true);

        try {
            const response = await fetch(
                `${API_BASE_URL}/prd/sendEmail`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(values),
                }
            );
            const result = await response.json();

            if (response.ok) {
                resetForm();
                await Swal.fire({
                    icon: "success",
                    title: "¡Enviado con éxito!",
                    text: "Tu mensaje ha sido enviado correctamente.",
                    confirmButtonColor: "#1226AA",
                    confirmButtonText: "Aceptar"
                });
            } else {
                await Swal.fire({
                    icon: "error",
                    title: "Error al enviar",
                    text: result.message || "Ocurrió un error al enviar tu mensaje.",
                    confirmButtonColor: "#d33",
                    confirmButtonText: "Cerrar"
                });
            }
        } catch (error) {
            await Swal.fire({
                icon: "error",
                title: "Error de conexión",
                text: "No pudimos conectar con el servidor.",
                confirmButtonColor: "#d33",
                confirmButtonText: "Cerrar"
            });
        } finally {
            setLoading(false);
        }
    };
    return (
        <div className="container contact-container">
            <div className="row justify-content-center">
                <div className="col-md-4">
                    {/* Aquí va tu sección de contacto */}
                    <h1>{dataContacto.titulos.contacto}</h1>
                    {dataContacto.telefonos.map((t, i) => (
                        <div key={i} className="container-number">
                            <a href={`tel:${t.numero}`}>{t.numero}</a>
                            <span>{t.region}</span>
                        </div>
                    ))}
                    <h3>
                        {dataContacto.titulos.siguen} <br />
                        <span>{dataContacto.titulos.redes}</span>
                    </h3>
                    <div className="content-socials">
                        {dataContacto.redesSociales.map((social, idx) => {
                            const Icon = iconMap[social.icono];
                            return (
                                <a
                                    key={idx}
                                    href={social.link}
                                    target="_blank"
                                    rel="noreferrer"
                                    className={`icon ${social.plataforma}`}
                                >
                                    {Icon && <Icon />}
                                </a>
                            );
                        })}
                    </div>
                </div>

                <div className="col-md-4">
                    {/* Aquí va tu formulario */}
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <Input
                            placeholder={data.formSection.fields.namePlaceholder}
                            variant="Simple"
                            value={values.name}
                            onChange={handleChange("name")}
                            onBlur={handleBlur("name")}
                            error={setErrorFormSimpleUtil(errors, touched, "name")}
                            success={!setErrorFormSimpleUtil(errors, touched, "name")}
                        />

                        <Input
                            placeholder={data.formSection.fields.emailPlaceholder}
                            variant="Simple"
                            value={values.email}
                            onChange={handleChange("email")}
                            onBlur={handleBlur("email")}
                            error={setErrorFormSimpleUtil(errors, touched, "email")}
                            success={!setErrorFormSimpleUtil(errors, touched, "email")}
                        />

                        <Input
                            placeholder={data.formSection.fields.phonePlaceholder}
                            variant="Simple"
                            value={values.phone}
                            onChange={handleChange("phone")}
                            onBlur={handleBlur("phone")}
                            error={setErrorFormSimpleUtil(errors, touched, "phone")}
                            success={!setErrorFormSimpleUtil(errors, touched, "phone")}
                        />

                        <Input
                            placeholder={data.formSection.fields.servicePlaceholder}
                            variant="Simple"
                            value={values.service}
                            onChange={handleChange("service")}
                            onBlur={handleBlur("service")}
                            error={setErrorFormSimpleUtil(errors, touched, "service")}
                            success={!setErrorFormSimpleUtil(errors, touched, "service")}
                        />

                        <Input
                            placeholder={data.formSection.fields.direccionPlaceholder}
                            variant="Simple"
                            value={values.address}
                            onChange={handleChange("address")}
                            onBlur={handleBlur("address")}
                            error={setErrorFormSimpleUtil(errors, touched, "address")}
                            success={!setErrorFormSimpleUtil(errors, touched, "address")}
                        />

                        <Input
                            placeholder={data.formSection.fields.messagePlaceholder}
                            variant="Textarea"
                            value={values.message}
                            onChange={handleChange("message")}
                            onBlur={handleBlur("message")}
                            error={setErrorFormSimpleUtil(errors, touched, "message")}
                            success={!setErrorFormSimpleUtil(errors, touched, "message")}
                        />

                        <Button
                            text={loading ? "Enviando..." : data.formSection.buttonText}
                            action={() => handleSubmit(values)}
                            disabled={!isValid || loading}
                            fill
                            color="red"
                        />
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Form